<div class="m-question default d-flex flex-column m-question-{{qID}}" [attr.data-qid]="qID"
	[ngClass]="{
		'edit': qID==parentComponent.editQid || qID===parentComponent.editQuestion,
		'read-only': parentComponent.isVisible(qID) 
	}">
	<div class="dev_qid">#{{qID}}</div>  <!-- debug -->
	<div class="m-question-content">
		<ng-content></ng-content>
	</div>
	<div class="m-question-action m-4" *ngIf="parentComponent.visibleQids && (parentComponent.editQid!=qID)">
		<button type="button" class="btn btn-secondary edit" (click)="edit(qID);">
			<i class="fa fa-pencil px-1" aria-hidden="true"></i>{{"COMMON.EDIT" | translate}}
		</button>
		<!-- <button class="save" (click)="save()">save</button> -->
		<!-- <button type="button" class="cancel" (click)="parentComponent.editQuestion=null">{{"COMMON.CANCEL" | translate}}</button> -->
	</div>
</div>

<!-- <pre class="dev compact">
	qID: {{qID}}
	parentComponent.prevQid : {{parentComponent.prevQid}}
	parentComponent.editQid : {{parentComponent.editQid}}
	parentComponent.editQuestion: {{parentComponent.editQuestion}}
	parentComponent.visibleQids:{{parentComponent.visibleQids}}

	parentComponent.isVisible(qID): {{parentComponent.isVisible(qID)}}
	qID===parentComponent.prevQid: {{qID===parentComponent.prevQid}}
	qID===parentComponent.editQid: {{qID===parentComponent.editQid}}
	qID===parentComponent.editQuestion: {{qID===parentComponent.editQuestion}}
	parentComponent.visibleQids && (!(parentComponent.editQid) || parentComponent.editQid==='all') = {{parentComponent.visibleQids && (!(parentComponent.editQid) || parentComponent.editQid==='all')}}
--------------------------------------------------------------------------------------
	'edit': qID==parentComponent.editQid || qID===parentComponent.editQuestion : {{qID==parentComponent.editQid || qID===parentComponent.editQuestion}}
	'read-only': parentComponent.isVisible(qID) : {{parentComponent.isVisible(qID)}}
	'prev': qID===parentComponent.prevQid : {{qID===parentComponent.prevQid}}

</pre> -->


// WEBPACK FOOTER //
// ./src/app/question/question.component.html